import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from 'redux/actions/sessionActions';
import logo1 from 'assets/images/ebiTrade_white.png';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'assets/css/signin.css';
import { Translate, I18n } from 'react-redux-i18n';

const ConfirmEmail = (props) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get('t');
  const [status, setStatus] = useState(token ? 'loading' : 'missing');

  useEffect(() => {
    if (!token) {
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const result = await props.confirmEmail(token);
        if (cancelled) {
          return;
        }
        if (result?.alreadyConfirmed) {
          setStatus('already');
          alertify.message(I18n.t('confirm_email_already'));
        } else {
          setStatus('success');
          alertify.success(I18n.t('confirm_email_success'));
        }
      } catch (error) {
        if (cancelled) {
          return;
        }
        setStatus('error');
        alertify.error(error.message || I18n.t('confirm_email_invalid'));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, props]);

  const titleKey = {
    loading: 'confirm_email_loading',
    missing: 'confirm_email_missing',
    success: 'confirm_email_success_title',
    already: 'confirm_email_already_title',
    error: 'confirm_email_error_title',
  }[status];

  const subtitleKey = {
    loading: null,
    missing: null,
    success: 'confirm_email_success',
    already: 'confirm_email_already',
    error: 'confirm_email_invalid',
  }[status];

  return (
    <div className="sign-in-page">
      <div className="signin-container">
        <div className="signin-hero">
          <img alt="Logo" src={logo1} className="img-logo" />
          <h1>Trading Log / Bitácora de Trading</h1>
          <p>Elecsotech</p>
        </div>

        <div className="signin-card">
          <div className="sign-in-content">
            <div className="signin-header">
              <h2 className="signin-title">
                <Translate value={titleKey} />
              </h2>
              {subtitleKey && (
                <span className="signin-subtitle">
                  <Translate value={subtitleKey} />
                </span>
              )}
              {status === 'loading' && (
                <span className="confirm-email-spinner" aria-hidden="true" />
              )}
            </div>

            <p className="signin-sugestion mt-3">
              <Link className="linked-primary link-underline-opacity-0" to="/login">
                <Translate value="sign_in" />
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmEmail.propTypes = {
  confirmEmail: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  confirmEmail: (token) => dispatch(actions.confirmEmail(token)),
});

export default connect(null, mapDispatchToProps)(withRouter(ConfirmEmail));
